// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__LDe70lUgGn{height:100%}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/team/components/teamTableEmptyState/teamTableEmptyState.module.scss"],"names":[],"mappings":"AAAA,qBACE,WAAA","sourcesContent":[".wrapper {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__LDe70lUgGn`
};
export default ___CSS_LOADER_EXPORT___;
